// @ts-nocheck 4345e6a8
import React from 'react';
import { cx } from '#packages/util';

export default class extends React.Component {
  static displayName = 'textEffectButton';

  render() {
    return (
      <span className={this.props.className}>
        <button
          onClick={this.props.onClick}
          className={cx({
            'text-effect-button': true,
            selected: this.props.isSelected,
          })}
        >
          <span>{this.props.children}</span>
        </button>
      </span>
    );
  }
}
